import { Button, Tooltip } from "antd";
import LogoutIcon from "mdi-react/LogoutIcon";
import UnfoldLessVerticalIcon from "mdi-react/UnfoldLessVerticalIcon";
import UnfoldMoreVerticalIcon from "mdi-react/UnfoldMoreVerticalIcon";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { toggleCollapsedSidebar } from "state/theme/themeSlice";
import { logOut } from "state/userInfo/userInfoSlice";

const SidebarCollapse = () => {
  const { collapsedSidebar } = useAppSelector((state) => state.theme);
  const dispatch = useAppDispatch();

  const toggleSidebar = () => {
    dispatch(toggleCollapsedSidebar());
  };

  const logout = () => {
    dispatch(logOut());
  };

  return (
    <div className="flex flex-col mt-auto mb-4">
      <Button
        onClick={logout}
        className="btn app-dashboard-sidebar-nav flex items-center mb-4 text-dark hover:!text-danger hover:!border-l-danger hover:!bg-neutral-danger"
      >
        <LogoutIcon size={22} className="shrink-0 mr-2" />
        <p>Đăng xuất</p>
      </Button>
      <Tooltip placement="top" title={!collapsedSidebar ? "Mở rộng" : "Thu gọn"}>
        <Button onClick={toggleSidebar} className="btn btn-icon text-dark hover:text-primary">
          {!collapsedSidebar ? (
            <UnfoldLessVerticalIcon size={25} className="hover:text-primary" />
          ) : (
            <UnfoldMoreVerticalIcon size={25} className="hover:text-primary" />
          )}
        </Button>
      </Tooltip>
    </div>
  );
};

export default SidebarCollapse;
